import React, { useState } from 'react'
import { STATUS, EVENTS, ACTIONS } from 'react-joyride'
import { CustomTour } from '../_molecules/_index'
import { useUserService } from '../../_services/_index'
import { useSelector, useDispatch } from 'react-redux'

const IntroGuideTour = ({ introSteps, section, isAliTourTriggered, setIsAliTourTriggered }) => {
  const { updateUserProfileInformation } = useUserService()
  const [stepIndex, setStepIndex] = useState(0)
  const [disableScrolling, setDisableScrolling] = useState(true)
  const APP_STORE_SECTION = 'app-store'
  const WORKSPACE_SECTION = 'workspace'
  const CHATBOT_SECTION = 'chat'
  const dispatch = useDispatch()
  const profileInfo = useSelector((state) => state?.profileReducer?.profile)

  //commented to remove profileSetupCompleted check
  // if (profileInfo?.userMetaData?.isProfileSetupCompleted !== true) {
  //   return null
  // }

  if (
    profileInfo?.userMetaData?.isAppStoreTourCompleted &&
    section &&
    section === APP_STORE_SECTION
  ) {
    return null
  }

  if (
    profileInfo?.userMetaData?.isWorkspaceTourCompleted &&
    section &&
    section === WORKSPACE_SECTION
  ) {
    return null
  }

  if (
    profileInfo?.userMetaData?.isAliTourCompleted &&
    section &&
    section === CHATBOT_SECTION &&
    !isAliTourTriggered
  ) {
    return null
  }

  return (
    <CustomTour
      disableScrolling={disableScrolling}
      steps={introSteps}
      continuous
      showSkipButton
      disableOverlayClose
      hideBackButton={false}
      callback={(data) => {
        const { action, index, status, type, size } = data

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
          setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1))

          if (index === 1) {
            setDisableScrolling(!disableScrolling)
          }
        } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
          let request = {}

          if (section === APP_STORE_SECTION) {
            request = { isAppStoreTourCompleted: true }
          } else if (section === WORKSPACE_SECTION) {
            request = { isWorkspaceTourCompleted: true }
          } else if (section === CHATBOT_SECTION) {
            request = { isAliTourCompleted: true }
          }
          if (isAliTourTriggered) setIsAliTourTriggered(false)
          else {
            updateUserProfileInformation(request)
              .then((response) => {
                if (response && response?.status === 'Success') {
                  const updatedData = {
                    ...profileInfo,
                    userMetaData: {
                      ...profileInfo?.userMetaData,
                      ...request
                    }
                  }
                  dispatch({ type: 'SET_PROFILE', payload: updatedData })
                  localStorage.setItem('userInfoData', JSON.stringify(updatedData))
                }
              })
              .catch((error) => {
                console.error(`An unexpected error occured ${error}.`)
              })
          }
        }
      }}
    />
  )
}

export default React.memo(IntroGuideTour)
